<template src="./Header.html"></template>

<script>
export default {
  name: "Header"
};
</script>

<style src="./Header.scss" lang="scss"></style>
